import React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';

const TimelineProviderQuickAdd = ({ review }) => {
  if (!review?.draft) return null;

  if (!review.providerAddOpen) {
    return (
      <Button
        variant="text"
        onClick={review.openProviderAdd}
        sx={{ mt: 0.5, px: 0, justifyContent: 'flex-start', textTransform: 'none', fontWeight: 700 }}
      >
        Provider not listed? Add provider (optional)
      </Button>
    );
  }

  return (
    <Box sx={{ mt: 1, p: 1.25, border: '1px solid #D8E2DE', borderRadius: 2 }}>
      <Typography sx={{ mb: 1, fontSize: '0.82rem', fontWeight: 800 }}>
        Add provider
      </Typography>
      <Box sx={{ display: 'grid', gap: 1 }}>
        <TextField
          size="small"
          label="Provider name *"
          value={review.providerDraft.name}
          onChange={(event) => review.updateProviderDraft('name', event.target.value)}
        />
        <TextField
          size="small"
          label="Specialty"
          value={review.providerDraft.specialty}
          onChange={(event) => review.updateProviderDraft('specialty', event.target.value)}
        />
        <TextField
          size="small"
          label="Organization"
          value={review.providerDraft.organizationName}
          onChange={(event) => review.updateProviderDraft('organizationName', event.target.value)}
        />
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="contained"
            disabled={!review.providerDraft.name.trim() || review.providerSaving}
            onClick={review.saveProvider}
            sx={{ textTransform: 'none', fontWeight: 800 }}
          >
            {review.providerSaving ? 'Adding…' : 'Add provider'}
          </Button>
          <Button
            variant="text"
            disabled={review.providerSaving}
            onClick={review.closeProviderAdd}
            sx={{ textTransform: 'none' }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default TimelineProviderQuickAdd;
